<template>
    <v-container>
        <v-row>
            <v-col class="d-flex justify-center">
                <h1 class="text-uppercase page-header text-center">Let's get in touch</h1>
            </v-col>
        </v-row>
        <v-row class="mb-3">
            <v-col class="d-flex justify-center">
                <h3 class="page-sub-header text-center" v-html="emailHrefElement" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <prism-editor class="contact-code-editor" v-model="code" :highlight="highlighter" line-numbers readonly></prism-editor>
            </v-col>
        </v-row>
        <v-row style="justify-content: center">
            <v-col cols="12" lg="3" xl="3">
                <v-select :items="contactMethods" v-model="methodSelected" dense solo dark/>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <v-btn block dark @click="openContactMethod">
                    <span><font-awesome-icon :icon="['fas', 'play']" class="mr-3" /></span>
                    <span>Run Code</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import contacts from '@/data/contact.json';

  import { PrismEditor } from 'vue-prism-editor';
  import 'vue-prism-editor/dist/prismeditor.min.css';
  import { highlight, languages } from 'prismjs/components/prism-core';
  import 'prismjs/components/prism-clike';
  import 'prismjs/components/prism-javascript'
  import 'prismjs/themes/prism-tomorrow.css';

  export default {
    name: 'Contact',
    components: {
      PrismEditor,
    },
    data: () => ({
        emailHrefElement: `<a href="${contacts.filter(c => c.title == "Email")[0].link}" target="_blank" rel="noopener noreferrer" class="email-link"><span class="text">${contacts.filter(c => c.title == "Email")[0].displayText}</span></a>`,
        code: '',
        methodSelected: contacts[0].title,
        contactMethods: contacts.map(c => c.title)
    }),
    mounted() {
        this.buildContactMethodCodeDisplay();
    },
    updated() {
        this.toggleLineNumberSelection(this.methodSelected, true);
    },
    watch: {
        methodSelected(newVal, oldVal) {
            this.toggleLineNumberSelection(oldVal, false);
            this.toggleLineNumberSelection(newVal, true);
        }
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.js); // languages.<insert language> to return html with markup
        },
        buildContactMethodCodeDisplay() {
            var cases = '';
            contacts.forEach(contact =>
            {
                cases += '\t\tcase ' + contact.title + ':';
                cases += '\n';
                cases += '\t\t\treturn "' + contact.displayText + '";';
                cases += '\n';
            });
            this.code = `string GetConnectionInfo(ConnectionMethod method)\n{\n\t switch(method)\n\t { \n${cases}\t}\n}`;
        },
        toggleLineNumberSelection(contactMethod, isOn) {
            var selectedContact = contacts.filter(c => c.title === contactMethod)[0];
            if (selectedContact && selectedContact.lineNumbers.length > 0)
            {
                var lineNumbersElement = document.getElementsByClassName('prism-editor__line-number');
                
                if (lineNumbersElement)
                    Array.from(lineNumbersElement).forEach((elm, index) => {
                        elm.classList.remove("execute-line");

                        // Have to add 1 because lineNumber is 1 based whereas the loop is 0 based
                        if (isOn && selectedContact.lineNumbers.includes(index + 1))
                            elm.classList.add("execute-line");
                    });
            }
        },
        openContactMethod() {
            window.open(contacts.filter(c => c.title == this.methodSelected)[0].link, '_blank', 'noopener,noreferrer');
        }
    },
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';

.email-link {
    text-decoration: none;

    .text {
        font-weight: bold;
        color: $hyperlink;
    }
}

.email-link:hover {
    .text:hover {
        color: $iconButton-hover;
    }
}

.contact-title {
    width: 90%;
    border-bottom: 2px solid black;
}

.contact-code-editor {
    background: $background;
    color: #ccc;

    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 1.5rem;
    line-height: 1.5;
    padding: 5px;
}

.prism-editor__line-numbers {
    .prism-editor__line-number.execute-line {
       color: rgba(255, 0, 0, 0.849);
    } 
    .prism-editor__line-number.execute-line::before {
        content: " · ";
        font-weight: bold;
    }
}


@media screen and (max-width: 600px)
{
    .contact-title {
        width: 100%;
    }

    .contact-code-editor {
        font-size: 0.8rem;
    }
}

@media screen and (max-width: 350px)
{
    .contact-code-editor {
        font-size: 0.6rem;
    }
}

</style>

